import { render, staticRenderFns } from "./FormularioApensar.vue?vue&type=template&id=1e41cd52&scoped=true"
import script from "./FormularioApensar.vue?vue&type=script&lang=js"
export * from "./FormularioApensar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e41cd52",
  null
  
)

export default component.exports